export default (function ($) {

    var _instance = {}

    var socialWindow = function (url) {
        var left = (screen.width - 570) / 2;
        var top = (screen.height - 570) / 2;
        var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
        window.open(url, "NewWindow", params);
    }

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {
            var pageUrl = encodeURIComponent(document.URL);
            var tweet = encodeURIComponent($("meta[property='og:description']").attr("content"));

            $(".js-social-share-facebook").on("click", function () {
                var url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
                socialWindow(url);
            });

            $(".js-social-share-twitter").on("click", function () {
                var url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + tweet;
                socialWindow(url);
            });

            $(".js-social-share-linkedin").on("click", function () {
                var url = "https://www.linkedin.com/shareArticle?mini=true&url=" + pageUrl;
                socialWindow(url);
            })

            $(".js-social-share-print").on("click", function () {
                window.print();
            });
        });
    };

    return _instance;

})(jQuery)